import React, { createContext, useContext, useEffect, useState } from "react";
import type { TiendaInfoDTO } from "@ecommerce/http-services";
import { HttpTiendaInfo } from "../http";

type TiendaInfoContextValue = TiendaInfoDTO | null;

const TiendaInfoContext = createContext<TiendaInfoContextValue>(null);

export function TiendaInfoProvider({ children }: { children: React.ReactNode }) {
    const [tiendaInfo, setTiendaInfo] = useState<TiendaInfoDTO | null>(null);

    const fetchTiendaInfo = () => {
        HttpTiendaInfo.get()
            .then(setTiendaInfo)
            .catch(() => {});
    };

    useEffect(() => {
        fetchTiendaInfo();
        const handleFocus = () => fetchTiendaInfo();
        window.addEventListener("focus", handleFocus);
        return () => window.removeEventListener("focus", handleFocus);
    }, []);

    return (
        <TiendaInfoContext.Provider value={tiendaInfo}>
            {children}
        </TiendaInfoContext.Provider>
    );
}

export function useTiendaInfo(): TiendaInfoDTO | null {
    return useContext(TiendaInfoContext);
}
